import { render } from "./pivot-practice.vue?vue&type=template&id=966692ba"
import script from "./pivot-practice.vue?vue&type=script&lang=js"
export * from "./pivot-practice.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__